const list = {
    buttonList: [
        {
            jurName: "获取验证码",
            actionType: 1,
        },
        {
            jurName: "获取二维码",
            actionType: 2,
        },
        {
            jurName: "开票",
            actionType: 0,
        },
        {
            jurName: "修改备注",
            actionType: 6,
        },
        {
            jurName: "退货红冲",
            actionType: 9,
        },
        {
            jurName: "退补红冲",
            actionType: 10,
        },
    ],
    buttonListJG: [
        {
            jurName: "获取验证码",
            actionType: 1,
        },
        {
            jurName: "获取二维码",
            actionType: 2,
        },
        {
            jurName: "红冲",
            actionType: 3,
        },
        {
            jurName: "回退",
            actionType: 5,
        },
        {
            jurName: "再次推送",
            actionType: 8,
        },
        {
            jurName: "下载发票",
            actionType: 4,
        },
        {
            jurName: "批量打印",
            actionType: 7,
        },
    ],
    searchList: [
        {
            showField: "开始时间",
            entityField: "start",
            isShow: 1,
            fieldType: "date",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "结束时间",
            entityField: "end",
            isShow: 1,
            fieldType: "date",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "销售单位",
            entityField: "cmName",
            isShow: 1,
            fieldType: "search",
            searchId: 3391151360249856,
            formatterContent: null,
            isRift: null,
            riftField: null,
            setField: "cmName,cmId",
            fieldWeight: 120,
        },
        {
            showField: "业务员",
            entityField: "salesName",
            isShow: 1,
            fieldType: "search",
            searchId: 4444770562019328,
            formatterContent: null,
            isRift: null,
            riftField: null,
            setField: "salesName,salesId",
            fieldWeight: 120,
        },
        {
            showField: "货主",
            entityField: "coName",
            isShow: 1,
            fieldType: "search",
            searchId: 4414428383875072,
            formatterContent: null,
            isRift: null,
            riftField: null,
            setField: "coName,coId",
            fieldWeight: 120,
        },
        {
            showField: "数据来源",
            entityField: "orderSource",
            isShow: 1,
            fieldType: "string",
            searchId: null,
            formatterContent: null,
            isRift: null,
            riftField: null,
            setField: null,
            fieldWeight: 120,
        },
        {
            showField: "订单类型",
            entityField: "businessType",
            isShow: 1,
            fieldType: "select",
            searchId: null,
            formatterContent: [
                {
                    key: "销售出库",
                    value: '销售出库',
                },
                {
                    key: "销售退补",
                    value: "销售退补",
                },
                {
                    key: "销售退货",
                    value: "销售退货",
                },
            ],
            isRift: null,
            riftField: null,
            setField: null,
            fieldWeight: 120,
        },
        {
            showField: "单据编号",
            entityField: "businessId",
            isShow: 1,
            fieldType: "string",
            searchId: null,
            formatterContent: null,
            isRift: null,
            riftField: null,
            setField: null,
            fieldWeight: 120,
        },
        {
            showField: "收货地址",
            entityField: "caiAddress",
            isShow: 1,
            fieldType: "string",
            searchId: null,
            formatterContent: null,
            isRift: null,
            riftField: null,
            setField: null,
            fieldWeight: 120,
        },
    ],
    searchListJG: [
        {
            showField: "开始时间",
            entityField: "start",
            isShow: 1,
            fieldType: "date",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "结束时间",
            entityField: "end",
            isShow: 1,
            fieldType: "date",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "销售单位",
            entityField: "cmName",
            isShow: 1,
            fieldType: "search",
            searchId: 3391151360249856,
            formatterContent: null,
            isRift: null,
            riftField: null,
            setField: "cmName,cmId",
            fieldWeight: 120,
        },
        {
            showField: "发票号",
            entityField: "ticketNum",
            isShow: 1,
            fieldType: "string",
            searchId: null,
            formatterContent: null,
            isRift: null,
            riftField: null,
            setField: null,
            fieldWeight: 120,
        },
        {
            showField: "状态",
            entityField: "state",
            isShow: 1,
            searchId: null,
            fieldType: "select",
            formatterContent: [
                { key: "初始", value: 0, },
                { key: "开票成功", value: 1, },
                { key: "已获取链接", value: 2, },
                { key: "待红冲申请", value: 3, },
                { key: "已红冲申请", value: 4, },
                { key: "红冲成功", value: 5, },
                { key: "开票失败", value: -1, }
            ],
            isRift: null,
            riftField: null,
            setField: null,
            fieldWeight: 120,
        },
        {
            showField: "单号",
            entityField: "businessId",
            isShow: 1,
            fieldType: "string",
            searchId: null,
            formatterContent: null,
            isRift: null,
            riftField: null,
            setField: null,
            fieldWeight: 120,
        },
        {
            showField: "发票类型",
            entityField: "billType",
            isShow: 1,
            searchId: null,
            fieldType: "select",
            formatterContent: [
                { key: "普票", value: "普票", },
                { key: "专票", value: "专票", },
            ],
            isRift: null,
            riftField: null,
            setField: null,
            fieldWeight: 120,
        },
    ],
    dataList: [
        {
            showField: "单据编号",
            entityField: "businessId",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 140,
        },
        {
            showField: "申请单号",
            entityField: "professId",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 150,
        },
        {
            showField: "发票类型",
            entityField: "billType",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 80,
        },
        {
            showField: "日期",
            entityField: "createTime",
            isShow: 1,
            fieldType: "date",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 100,
        },
        {
            showField: "单位编号",
            entityField: "cmCode",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "单位名称",
            entityField: "cmName",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 160,
        },
         {
            showField: "总含税金额",
            entityField: "totalMoney",
            isShow: 1,
            fieldType: "number",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 100,
        },
        {
            showField: "价税合计",
            entityField: "oldMoney",
            isShow: 1,
            fieldType: "number",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 100,
        },
        {
            showField: "购货方名称",
            entityField: "cmName",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 160,
        },
        {
            showField: "购货方识别号",
            entityField: "cmSocialcode",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 180,
        },
        {
            showField: "购货方银行及账号",
            entityField: "cmBankAccount",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 160,
        },
        {
            showField: "购货方地址电话",
            entityField: "cmAddressPhone",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 180,
        },
        {
            showField: "销售方银行及账号",
            entityField: "orgBankAccount",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 160,
        },
        {
            showField: "销售方地址电话",
            entityField: "orgAddressPhone",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 180,
        },
        {
            showField: "已开票金额",
            entityField: "billMoney",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },

        {
            showField: "订单类型",
            entityField: "businessType",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },

        {
            showField: "是否已开票",
            entityField: "isBill",
            isShow: 1,
            fieldType: "formatter",
            formatterContent: [
                {
                    key: "是",
                    value: 1,
                },
                {
                    key: "否",
                    value: 0,
                },
            ],
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "总金额",
            entityField: "totalntaxMoney",
            isShow: 1,
            fieldType: "number",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 100,
        },
        {
            showField: "业务员",
            entityField: "opmName",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 100,
        },
        {
            showField: "货主",
            entityField: "coName",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 150,
        },
        
        {
            showField: "对方业务员",
            entityField: "salesName",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 100,
        },
        {
            showField: "总数量",
            entityField: "totalNumber",
            isShow: 1,
            fieldType: "number",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 100,
        },
        {
            showField: "税额",
            entityField: "taxMoney",
            isShow: 1,
            fieldType: "number",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 100,
        },
        {
            showField: "推送方式",
            entityField: "pushMethod",
            isShow: 1,
            fieldType: "formatter",
            formatterContent: [
                {
                    key: "不推送",
                    value: 0,
                },
                {
                    key: "短信",
                    value: 1,
                },
                {
                    key: "邮箱",
                    value: 2,
                },
                {
                    key: "全部",
                    value: 3,
                },
            ],
            isRift: null,
            riftField: null,
            fieldWeight: 100,
        },
        {
            showField: "推送手机号",
            entityField: "pushPhone",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 180,
        },
        {
            showField: "推送邮箱",
            entityField: "pushEmail",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 180,
        },
        {
            showField: "备注",
            entityField: "woamRemark",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 200,
        },
    ],
    dataDetailsList: [
        {
            showField: "通用名称",
            entityField: "bgmName",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "规格型号",
            entityField: "spec",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "包装单位",
            entityField: "bgpUnitmeasurement",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "生产厂商",
            entityField: "manufacturer",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "商品数量",
            entityField: "businessNum",
            isShow: 1,
            fieldType: "number",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "可开票数量",
            entityField: "invoicableQuantity",
            isShow: 1,
            fieldType: "number",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "开票数量",
            entityField: "ddinCount",
            isShow: 1,
            fieldType: "input_number",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "单价",
            entityField: "price",
            isShow: 1,
            fieldType: "number",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "含税价",
            entityField: "psprice",
            isShow: 1,
            fieldType: "number",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "含税金额",
            entityField: "psmoney",
            isShow: 1,
            fieldType: "number",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "金额",
            entityField: "money",
            isShow: 1,
            fieldType: "number",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "税率",
            entityField: "outRate",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "零税率",
            entityField: "zeroMark",
            isShow: 1,
            fieldType: "formatter",
            formatterContent: [
                {
                    key: "正常税率",
                    value: 0,
                },
                {
                    key: "出口免税和其他免税优惠政策(免税)",
                    value: 1,
                },
                {
                    key: "不征增值税(不征税)",
                    value: 2,
                },
                {
                    key: "普通零税率(0%)",
                    value: 3,
                },
            ],
            isRift: null,
            riftField: null,
            fieldWeight: 140,
        },
        {
            showField: "特殊增值税",
            entityField: "specialTax",
            isShow: 1,
            fieldType: "formatter",
            formatterContent: [
                {
                    key: "简易征收",
                    value: '简易征收',
                },
                {
                    key: "稀土产品",
                    value: '稀土产品',
                },
                {
                    key: "免税",
                    value: '免税',
                },
                {
                    key: "不征税",
                    value: '不征税',
                },
                {
                    key: "先征后退",
                    value: '先征后退',
                },
                {
                    key: "100%先征后退",
                    value: '100%先征后退',
                },
                {
                    key: "50%先征后退",
                    value: '50%先征后退',
                },
                {
                    key: "按3%简易征收",
                    value: '按3%简易征收',
                },
                {
                    key: "按5%简易征收",
                    value: '按5%简易征收',
                },
                {
                    key: "按5%简易征收减按1.5%计征",
                    value: '按5%按5%简易征收减按1.5%计征',
                },
                {
                    key: "即征即退30%",
                    value: '即征即退30%',
                },
                {
                    key: "即征即退50%",
                    value: '即征即退50%',
                },
                {
                    key: "即征即退70%",
                    value: '即征即退70%',
                },
                {
                    key: "即征即退100%",
                    value: '即征即退100%',
                },
                {
                    key: "超税负3%即征即退",
                    value: '超税负3%即征即退',
                },
                {
                    key: "超税负8%即征即退",
                    value: '超税负8%即征即退',
                },
                {
                    key: "超税负12%即征即退",
                    value: '超税负12%即征即退',
                },
                {
                    key: "超税负6%即征即退",
                    value: '超税负6%即征即退',
                },
            ],
            isRift: null,
            riftField: null,
            fieldWeight: 180,
        },
        {
            showField: "优惠政策",
            entityField: "discountMark",
            isShow: 1,
            fieldType: "formatter",
            formatterContent: [
                {
                    key: "使用",
                    value: 1,
                },
                {
                    key: "未使用",
                    value: 0,
                },
            ],
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "税额",
            entityField: "taxAmount",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "单据编号",
            entityField: "businessId",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 140,
        },
        {
            showField: "订单类型",
            entityField: "businessType",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "批号",
            entityField: "batchno",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },

        {
            showField: "生产日期",
            entityField: "prodate",
            isShow: 1,
            fieldType: "date",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },

        {
            showField: "失效日期",
            entityField: "expidate",
            isShow: 1,
            fieldType: "date",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
    ],
    dataListJG: [
        {
            showField: "单据编号",
            entityField: "businessId",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 160,
        },
        {
            showField: "申请单号",
            entityField: "professId",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 160,
        },
        // {
        //     showField: "记账日期",
        //     entityField: "psacmDate",
        //     isShow: 1,
        //     fieldType: "date",
        //     formatterContent: null,
        //     isRift: null,
        //     riftField: null,
        //     fieldWeight: 160,
        // },
        {
            showField: "摘要",
            entityField: "transmissionRemark",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 160,
        },
        {
            showField: "请求流水号",
            entityField: "aimId",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 160,
        }, {
            showField: "发票类型",
            entityField: "billType",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: '发票号码',
            entityField: "ticketNum",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        // {
        //     showField: '发票代码',
        //     entityField: "railNum",
        //     isShow: 1,
        //     fieldType: "string",
        //     formatterContent: null,
        //     isRift: null,
        //     riftField: null,
        //     fieldWeight: 120,
        // },
        {
            showField: '购货方名称',
            entityField: "cmName",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 180,
        },
        {
            showField: '购货方识别号',
            entityField: "cmSocialcode",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 160,
        },
        {
            showField: '含税金额',
            entityField: "poolPsmoney",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 100,
        },
        {
            showField: '不含税金额',
            entityField: "poolMoney",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 100,
        },
        {
            showField: '税额合计',
            entityField: "taxMoney",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 100,
        },
        {
            showField: '开票日期',
            entityField: "invoicingTime",
            isShow: 1,
            fieldType: "datetime",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 150,
        },
        {
            showField: '发票PDF链接',
            entityField: "pdfUrl",
            isShow: 1,
            fieldType: "url",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 200,
        },
        {
            showField: '状态',
            entityField: "state",
            isShow: 1,
            fieldType: "formatter",
            formatterContent: [
                {
                    key: "初始",
                    value: 0,
                },
                {
                    key: "开票成功",
                    value: 1,
                },
                {
                    key: "已获取链接",
                    value: 2,
                },
                {
                    key: "已推送",
                    value: 3,
                },
                {
                    key: "开票失败",
                    value: -1,
                },
            ],
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        }

    ],
    dataDetailsListJG: [
        {
            showField: "序号",
            entityField: "rowno",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "通用名称",
            entityField: "bgmName",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "规格型号",
            entityField: "spec",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "计量单位",
            entityField: "bgpUnitmeasurement",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "商品数量",
            entityField: "ddinCount",
            isShow: 1,
            fieldType: "number",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        // {
        //     showField: "冲红数量",
        //     entityField: "ddinCount",
        //     isShow: 1,
        //     fieldType: "number",
        //     formatterContent: null,
        //     isRift: null,
        //     riftField: null,
        //     fieldWeight: 120,
        // },
        // {
        //     showField: "可冲红数量",
        //     entityField: "ddinCount",
        //     isShow: 1,
        //     fieldType: "number",
        //     formatterContent: null,
        //     isRift: null,
        //     riftField: null,
        //     fieldWeight: 120,
        // },

        {
            showField: "含税价格",
            entityField: "psprice",
            isShow: 1,
            fieldType: "number",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "含税金额",
            entityField: "psmoney",
            isShow: 1,
            fieldType: "number",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "单价",
            entityField: "price",
            isShow: 1,
            fieldType: "number",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "金额",
            entityField: "money",
            isShow: 1,
            fieldType: "number",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "税率",
            entityField: "outRate",
            isShow: 1,
            fieldType: "number",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "零税率",
            entityField: "zeroMark",
            isShow: 1,
            fieldType: "formatter",
            formatterContent: [
                {
                    key: "正常税率",
                    value: 0,
                },
                {
                    key: "出口免税和其他免税优惠政策(免税)",
                    value: 1,
                },
                {
                    key: "不征增值税(不征税)",
                    value: 2,
                },
                {
                    key: "普通零税率(0%)",
                    value: 3,
                },
            ],
            isRift: null,
            riftField: null,
            fieldWeight: 140,
        },
        {
            showField: "特殊增值税",
            entityField: "specialTax",
            isShow: 1,
            fieldType: "formatter",
            formatterContent: [
                {
                    key: "简易征收",
                    value: '简易征收',
                },
                {
                    key: "稀土产品",
                    value: '稀土产品',
                },
                {
                    key: "免税",
                    value: '免税',
                },
                {
                    key: "不征税",
                    value: '不征税',
                },
                {
                    key: "先征后退",
                    value: '先征后退',
                },
                {
                    key: "100%先征后退",
                    value: '100%先征后退',
                },
                {
                    key: "50%先征后退",
                    value: '50%先征后退',
                },
                {
                    key: "按3%简易征收",
                    value: '按3%简易征收',
                },
                {
                    key: "按5%简易征收",
                    value: '按5%简易征收',
                },
                {
                    key: "按5%简易征收减按1.5%计征",
                    value: '按5%按5%简易征收减按1.5%计征',
                },
                {
                    key: "即征即退30%",
                    value: '即征即退30%',
                },
                {
                    key: "即征即退50%",
                    value: '即征即退50%',
                },
                {
                    key: "即征即退70%",
                    value: '即征即退70%',
                },
                {
                    key: "即征即退100%",
                    value: '即征即退100%',
                },
                {
                    key: "超税负3%即征即退",
                    value: '超税负3%即征即退',
                },
                {
                    key: "超税负8%即征即退",
                    value: '超税负8%即征即退',
                },
                {
                    key: "超税负12%即征即退",
                    value: '超税负12%即征即退',
                },
                {
                    key: "超税负6%即征即退",
                    value: '超税负6%即征即退',
                },
            ],
            isRift: null,
            riftField: null,
            fieldWeight: 180,
        },
        {
            showField: "优惠政策",
            entityField: "discountMark",
            isShow: 1,
            fieldType: "formatter",
            formatterContent: [
                {
                    key: "使用",
                    value: 1,
                },
                {
                    key: "未使用",
                    value: 0,
                },
            ],
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "税额",
            entityField: "taxMoney",
            isShow: 1,
            fieldType: "number",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "类型",
            entityField: "type",
            isShow: 1,
            fieldType: "formatter",
            formatterContent: [
                {
                    key: "正常行",
                    value: 0,
                },
                {
                    key: "折扣行",
                    value: 1,
                },
                {
                    key: "被折扣行",
                    value: 2,
                },
            ],
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
    ],
}
export default list
